<button class="iso-round-button" (click)="addLeave()">{{ 'bikeshop.users.add_leave' | translate}}</button>

<br/>
<br/>
<br/>
<div class="content">
  <full-calendar #calendar schedulerLicenseKey="0984855613-fcs-1539348025" ignoreTimezone="false"
                 [nowIndicator]="true"
                 [now]="getNowDate()" timeZone="UTC" defaultView="listWeek" [locales]="[ 'enLocale', 'esLocale' ]"
                 [header]="{
              right: 'prev, next, today',
              center: 'title',
              left: headerView
            }" [views]="{

            }" [buttonText]="calendarButtonText" [navLinks]="false" [rerenderDelay]="100" [showNonCurrentDates]="true"
                 [plugins]="calendarPlugins" [weekends]="calendarWeekends" [resources]="technicians"
                 [minTime]="minTime"
                 [maxTime]="maxTime" [eventLimit]="true" [allDaySlot]="false" [selectable]="true" [editable]="true"
                 [contentHeight]="contentHeight" (eventRender)="renderEvent($event)" (dateClick)="dateClicked($event)"
                 (eventClick)="scheduleClicked($event)" (eventDrop)="scheduleMoved($event)"
                 (eventResize)="scheduleDurationChanged($event)">
  </full-calendar>
  <!--  todo (dcorbett) fix full calendar-->
</div>
